<template>
  <jd-dialog
    align-center
    :visible.sync="visible"
    :show-close="true"
    title="奖品库存提示"
    :before-close="close"
    @confirm="submit"
    @close="close"
  >
    <div v-loading="loading">
      <el-form :model="prizeInventory" ref="formRef" label-width="100px">
        <el-form-item label="活动类型：">
          <div>{{ getActivityTypeName(prizeInventory.activityType) }}</div>
        </el-form-item>
        <el-form-item label="活动名称：">
          <div>{{ prizeInventory.activityName }}</div>
        </el-form-item>
        <el-form-item label="奖品信息：">
          <jd-table
            :tableData="prizeList"
            :tableInfo="tableInfo"
            v-if="prizeList.length > 0"
          >
            <template #prizeTypeSlot="{ row }">
              <div>{{ getPrizeTypeName(row.prizeType) }}</div>
            </template>
            <template #alertAmountSlot="{ row }">
              <el-input v-model="row.alertAmount" placeholder="不填则不预警" />
            </template>
          </jd-table>
          <div class="no-tip" v-else>暂无奖品信息</div>
        </el-form-item>
      </el-form>
    </div>
  </jd-dialog>
</template>

<script>
import {
  prizeStockWarningList,
  savePrizeStockWarning,
} from "@/api/jhk/activityController";
export default {
  name: "BatchUpload",
  props: {
    visible: Boolean,
    activityInfo: {
      type: Object,
      default: () => ({
        activityName: "",
        activityType: "",
        activityTypeStr: "",
      }),
    },
  },
  data() {
    return {
      loading: false,
      prizeInventory: {},
      prizeList: [],
      tableInfo: [
        {
          label: "奖品类型",
          slot: "prizeTypeSlot",
          minWidth: 142,
        },
        {
          label: "奖品名称",
          prop: "prizeName",
          minWidth: 142,
        },
        {
          label: "奖品数量（总）",
          prop: "totalAmount",
          minWidth: 142,
        },
        {
          label: "剩余数量",
          prop: "remanentAmount",
          minWidth: 142,
        },
        {
          label: "库存不足预警配置",
          slot: "alertAmountSlot",
          minWidth: 142,
        },
      ],
    };
  },
  mounted() {
    this.getPrizeInfo();
  },
  methods: {
    getPrizeInfo() {
      this.loading = true;
      prizeStockWarningList(this.activityInfo.id)
        .then((res) => {
          this.loading = false;
          if (res.code == 1) {
            this.prizeInventory = res.data || {
              activityType: this.activityInfo.activityType,
              activityName: this.activityInfo.activityName,
            };
            if (res.data.prize && res.data.prize.prizeId) {
              this.prizeList = [res.data.prize] || [];
            }
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    submit() {
      if (
        this.prizeList[0].alertAmount &&
        Number(this.prizeList[0].alertAmount) > this.prizeList[0].totalAmount
      ) {
        this.$message({
          message: "预警数量不可大于奖品数量",
          type: "warning",
        });
        return;
      }
      // TODO: 提交表单
      const pramss = {
        prizeId: this.prizeList[0].prizeId,
        alertAmount: this.prizeList[0].alertAmount,
      };
      savePrizeStockWarning(pramss).then((res) => {
        if (res.code == 1) {
          this.$message({
            message: "保存成功",
            type: "success",
          });
          this.$emit("close", true);
        } else {
          this.$message({
            message: res.message || "保存失败",
            type: "error",
          });
        }
      });
    },
    close() {
      this.$emit("close", false);
    },
  },
};
</script>

<style scoped lang="scss">
.no-tip {
  font-size: 14px;
  color: #bdbcbc;
}
</style>
